var __WEBPACK_NAMESPACE_OBJECT__ = window['i18n-react'];